import { motion } from "framer-motion";
import { ArrowSquareOut } from "@phosphor-icons/react";

const clubs = [
  {
    name: "Dunbar United FC",
    location: "Scotland",
    logo: "https://api.targetfunder.com/api/uploads/demo-1f79bdfa25504a2bb0d586897cf75866.png",
    url: "https://app.targetfunder.com/worldcup2026/dunbarunitedfc",
  },
  {
    name: "Ballymun United FC",
    location: "Ireland",
    logo: "https://api.targetfunder.com/api/uploads/onboard-4c2709231c004444ba2b8a8b72d4c56b.png",
    url: "https://app.targetfunder.com/worldcup2026/ballymununitedfc",
  },
  {
    name: "Wilton United FC",
    location: "Ireland",
    logo: "https://api.targetfunder.com/api/uploads/demo-5754b84c78444b2ab3b5df4f8038718e.png",
    url: "https://app.targetfunder.com/worldcup2026/wiltonunitedfc",
  },
  {
    name: "Bishopstown Tennis Club",
    location: "Ireland",
    logo: "https://api.targetfunder.com/api/uploads/demo-be569a87ddd44e7285fdf135ee209e65.jpg",
    url: "https://app.targetfunder.com/worldcup2026/bishopstowntennisclubjuniorprogramme",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.4 },
  }),
};

export default function LiveClubs() {
  return (
    <section
      id="live-clubs"
      data-testid="live-clubs-section"
      className="py-10 lg:py-14 px-6 bg-white border-t border-[#1D3557]/5"
    >
      <div className="max-w-6xl mx-auto">
        <p className="font-body text-xs font-bold uppercase tracking-[0.2em] text-[#E63946] mb-3">
          Live Now
        </p>
        <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl uppercase tracking-tight leading-none text-[#1D3557] mb-6 lg:mb-8">
          Clubs Already Fundraising
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-6">
          {clubs.map((club, i) => (
            <motion.a
              key={club.name}
              href={club.url}
              target="_blank"
              rel="noopener noreferrer"
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-30px" }}
              variants={fadeUp}
              className="border border-[#1D3557]/8 p-6 flex flex-col items-center text-center group hover:border-[#1D3557]/20 transition-all"
              data-testid={`live-club-${i}`}
            >
              <img
                src={club.logo}
                alt={`${club.name} logo`}
                className="w-16 h-16 object-contain rounded-full mb-3"
              />
              <h3 className="font-heading font-bold text-base tracking-tight text-[#1D3557] mb-1">
                {club.name}
              </h3>
              <p className="font-body text-xs text-[#1D3557]/40 mb-3">
                {club.location}
              </p>
              <span className="font-body text-xs font-semibold text-[#E63946] flex items-center gap-1 group-hover:gap-2 transition-all">
                View Site <ArrowSquareOut size={12} weight="bold" />
              </span>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
